module.exports = function() {
  return new Worker(__webpack_public_path__ + "28ae5d4e28b9dc4e8c9d.worker.js");
};